import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { toGenerateGmailToken } from "../../utils/APIs";
import ScreenLoader from "../../components/ScreenLoader";

const GmailCode = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    var code = location.search;
    toGenerateGmailToken(code.replace("?code=", "")).then((res) => {
      navigate("/admin");
    });
  });

  return (
    <>
      <ScreenLoader />
    </>
  );
};
export default GmailCode;
